import { makeStyles } from 'tss-react/mui';

const TOP_BAR_HEIGHT = 48;
const PAGE_PADDING_TOP = 16;

export const useStyles = makeStyles()((theme) => ({
    mainContainer: {
        height: '100vh',
        display: 'flex',
    },
    appContent: {
        flex: 1,
        marginTop: TOP_BAR_HEIGHT,
        height: `calc(100vh - ${TOP_BAR_HEIGHT}px)`,
        padding: theme.spacing(0, 3),
        // Bounded flex column — page scroll is off; DataTable scrolls internally.
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxSizing: 'border-box',
        fontSize: '110%',
    },
    pageContent: {
        paddingTop: PAGE_PADDING_TOP,
        paddingBottom: PAGE_PADDING_TOP,
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
    },
}));
